import { Component } from '@angular/core';
import { NavigService } from 'src/app/services/navig.service';

@Component({
  selector: 'app-footer2',
  templateUrl: './footer2.component.html',
  styleUrls: ['./footer2.component.scss']
})
export class Footer2Component {
  constructor(
    public nav : NavigService
  ){}

}
